import { ApiClient } from './client.js'
import { WAFFLE } from './resources.js'

const client = new ApiClient()

export default {
  waffleStatus () {
    return client.get(`${WAFFLE}`)
  }
}
